module.exports = __webpack_public_path__ + "img/reward-pop-up-window@3x.35d94ba4.png";